var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { merge } from "lodash";
import React from "react";
import {
  experimentStrategy,
  extractPluginsConfig,
  fetchEmbedData,
  runStrategies,
  themeStrategy
} from "./../wix-ricos-common";
import { RICOS_VERSION } from "./../ricos-schema/next-schema";
import { runViewerStrategies } from "./runViewerStrategies";
const createWixRicosViewer = (RicosViewer) => function WixRicosViewer(props) {
  const _a = props, {
    children,
    biSettings,
    instance,
    plugins,
    theme,
    wixExperiments,
    allowLinkPreviewPopover,
    httpClient,
    msid,
    baseUrl,
    previewMode,
    content
  } = _a, rest = __objRest(_a, [
    "children",
    "biSettings",
    "instance",
    "plugins",
    "theme",
    "wixExperiments",
    "allowLinkPreviewPopover",
    "httpClient",
    "msid",
    "baseUrl",
    "previewMode",
    "content"
  ]);
  const experiments = experimentStrategy(wixExperiments);
  const strategyProps = runStrategies({
    plugins,
    instance,
    biSettings,
    experiments,
    wixRicosVersion: RICOS_VERSION,
    ricosVersion: RICOS_VERSION,
    httpClient,
    msid,
    viewer: true,
    content
  });
  const _rcProps = merge(
    strategyProps,
    runViewerStrategies(plugins, baseUrl, previewMode),
    extractPluginsConfig(plugins, strategyProps.helpers)
  );
  return /* @__PURE__ */ React.createElement(
    RicosViewer,
    __spreadValues(__spreadValues({
      _rcProps,
      content,
      experiments: strategyProps.experiments,
      plugins,
      theme: themeStrategy(theme)
    }, allowLinkPreviewPopover && {
      linkPreviewPopoverFetchData: fetchEmbedData(instance)
    }), rest),
    children
  );
};
export {
  createWixRicosViewer
};
//# sourceMappingURL=WixRicosViewerNext.js.map
